import './style.css'
import Slider from "../Slider";

export default class OurPropertiesSlider {
    static selector = '.op-slider'

    constructor(block) {
        this.block = block;
    }

    onComplete() {
        new Slider({
            container: '#op-slider',
            controlsContainer: this.block.querySelector('.op-slider__nav'),
            gutter: 20,
            loop: true,
            fixedWidth: 295,
            responsive: {
                765: {
                    fixedWidth: false,
                    items: 2,
                    gutter: 30,
                },
                1025: {
                    gutter: 40,
                    autoplay: true,
                    autoplayButton: false,
                    items: 4,
                }
            }
        })
    }
}
